export const STATES = {
    OPENED: 'OPENED',
    CLOSED: 'CLOSED'
}

export const BAG_STATE_NAMES = {
    [STATES.CLOSED]: 'Zamknięty',
    [STATES.OPENED]: 'Otwarty'
}

export const MODES = {
    MERGE: 'merge',
    TRANSFER: 'transfer',
    IDLE: 'idle'
}